import React, { forwardRef, useRef, useEffect, useState, useMemo } from 'react';
import { Checkbox } from 'antd';
import {
  DEFALUT_PERMISSION_SECTION,
  PERMISSION_OPTION,
  BUYER_SIDE_INSIGHT,
  SELLER_SIDE_INSIGHT,
  DEFAULT_PERMISSION_SECTION_VALUES,
  GUIDING_PRINCIPLES_DIVESTITURES_KEY,
} from '@model';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import { deepCopy } from '@utils';
import { getDefaultOptions } from '@modules/systemSetting/systemModule/helper';

const CLIENT_DEFAULT_CHECKED = [
  DEFALUT_PERMISSION_SECTION.PEOJECT_LIST,
  DEFALUT_PERMISSION_SECTION.HOME,
  // ...PERMISSION_OPTION[DEFALUT_PERMISSION_SECTION.INSIGHT].map((item) => {
  //   if (CLIENT_INSIGHT.includes(item.value)) {
  //     // debugger;
  //     return item.value;
  //   }
  //   return null;
  // }),
  // ...PERMISSION_OPTION[DEFALUT_PERMISSION_SECTION.ANALYSIS].map(
  //   (item) => item.value,
  // ),
  // DEFALUT_PERMISSION_SECTION.STATUS_REPORTING,
  // DEFALUT_PERMISSION_SECTION.SYNERGY_TRACKER,
  // DEFALUT_PERMISSION_SECTION.TSA_ACCELERATOR,
  // DEFALUT_PERMISSION_SECTION.WORKFORCE_ARCHITECT,
];

const CLIENT_SELL_SIDE_DEFALUT_CHECKED = [
  DEFALUT_PERMISSION_SECTION.PEOJECT_LIST,
  DEFALUT_PERMISSION_SECTION.HOME,
  // DEFALUT_PERMISSION_SECTION.STATUS_REPORTING,
  // DEFALUT_PERMISSION_SECTION.TSA_ACCELERATOR,
  // DEFALUT_PERMISSION_SECTION.WORKFORCE_ARCHITECT,
];

const INTERNAL_DEFAULT_CHECKED = [
  DEFALUT_PERMISSION_SECTION.PEOJECT_LIST,
  DEFALUT_PERMISSION_SECTION.HOME,
  PERMISSION_OPTION[DEFALUT_PERMISSION_SECTION.QUESTIONNAIRE][0].value,
  ...PERMISSION_OPTION[DEFALUT_PERMISSION_SECTION.INSIGHT].map((item) => {
    if (BUYER_SIDE_INSIGHT.includes(item.value)) {
      // debugger;
      return item.value;
    }
    return null;
  }),
  ...PERMISSION_OPTION[DEFALUT_PERMISSION_SECTION.ANALYSIS].map(
    (item) => item.value,
  ),
  DEFALUT_PERMISSION_SECTION.STATUS_REPORTING,
  DEFALUT_PERMISSION_SECTION.SYNERGY_TRACKER,
  DEFALUT_PERMISSION_SECTION.TSA_ACCELERATOR,
  DEFALUT_PERMISSION_SECTION.WORKFORCE_ARCHITECT,
];
const INTERNAL_SELL_SIDE_DEFAULT_CHECKED = [
  DEFALUT_PERMISSION_SECTION.PEOJECT_LIST,
  DEFALUT_PERMISSION_SECTION.HOME,
  ...PERMISSION_OPTION[DEFALUT_PERMISSION_SECTION.INSIGHT].map((item) => {
    if (SELLER_SIDE_INSIGHT.includes(item.value)) {
      return item.value;
    }
    return null;
  }),
  ...PERMISSION_OPTION[DEFALUT_PERMISSION_SECTION.ANALYSIS].map(
    (item) => item.value,
  ),
  DEFALUT_PERMISSION_SECTION.STATUS_REPORTING,
  DEFALUT_PERMISSION_SECTION.TSA_ACCELERATOR,
  DEFALUT_PERMISSION_SECTION.WORKFORCE_ARCHITECT,
];

const PermissionCheckbox = forwardRef((props, ref) => {
  const inputRef = useRef(null);
  const {
    rowName,
    rowIndex,
    permissionType,
    groupId,
    isPureClientGroup,
    isEmptyGroup,
    formChange = () => {},
    config: { columns },
  } = props;
  const cellObj =
    props.formInstance?.getFieldValue?.([props.rowName, props.rowIndex]) || {}; // ✅ Add default empty object

  // ✅ Add early return if essential data is missing
  if (!cellObj || Object.keys(cellObj).length === 0) {
    console.warn('PermissionCheckbox: cellObj is undefined or empty', {
      rowName: props.rowName,
      rowIndex: props.rowIndex,
      hasFormInstance: !!props.formInstance,
    });
    return null; // or return a loading state
  }

  const location = useLocation();
  const allPureClientGroupIds = columns
    .filter((i) => i.formConfig.isPureClientGroup || i.formConfig.isEmptyGroup)
    .map((i) => i.formConfig.groupId);
  const { value: v, module, originPermissions } = cellObj;
  const { companyInstance, customizeModule = [] } = useSelector(
    (state) => state.projects.saveData,
  );
  // const permissionCheckboxOptions = useSelector(
  //   (state) => state.projects.permissionCheckboxOptions,
  // );
  const permissions = cellObj[permissionType];
  const checkedPermission =
    permissionType === 'groupPermissions'
      ? permissions?.find?.((item) => item.groupId === groupId)?.groupPermission
      : permissions?.map((item) => item.value);
  const isCustomizePermission = !DEFAULT_PERMISSION_SECTION_VALUES.includes(v);
  const defaultOptions = useMemo(
    () =>
      getDefaultOptions({
        key: v,
        moduleName: module,
        originPermissions,
        location,
        isCustomizePermission,
      }),
    [v, module, originPermissions, isCustomizePermission],
  );
  const [options, setOptions] = useState(defaultOptions);
  const [optionValue, setOptionValue] = useState(checkedPermission || []);

  const _instanceType = useSelector(
    (state) => state.common.projectCompanyInfo.instanceType,
  );
  const settingCompanyInstance = useSelector(
    (state) => state.common.settingCompanyInstance,
  );
  const instanceType = location.pathname.includes('/projects/setting')
    ? _instanceType
    : settingCompanyInstance;

  // useEffect(() => {
  //   if (
  //     instanceType === 'Customize' &&
  //     !isCustomizePermission &&
  //     v === DEFALUT_PERMISSION_SECTION.INSIGHT
  //   ) {
  //     setOptions(
  //       deepCopy(
  //         PERMISSION_OPTION[v].filter(
  //           (e) => e.value !== GUIDING_PRINCIPLES_DIVESTITURES_KEY,
  //         ),
  //       ),
  //     );
  //   }
  // }, [instanceType, v]);

  useEffect(() => {
    if (['clientPermissions', 'groupPermissions'].includes(permissionType)) {
      // sync form value to checkbox
      setOptionValue(checkedPermission || []);

      // check option if option should be disabled
      if (['projectList', 'Home'].includes(v)) {
        return;
      }
      const internalValue = cellObj.internalPermissions;
      const groupPermissionsValue = cellObj.groupPermissions;

      setOptions((currentOptions) =>
        currentOptions.map((option) => {
          const internalValueSelected = internalValue.find(
            (i) => i.value === option.value,
          );
          const allowGroupSelect = groupPermissionsValue?.some(
            (i) =>
              i.groupId !== groupId &&
              !allPureClientGroupIds.includes(i.groupId) &&
              i.groupPermission?.includes(option.value),
          );
          if (isEmptyGroup) {
            option.disabled = true;
          } else if (
            permissionType === 'clientPermissions' ||
            isPureClientGroup
          ) {
            option.disabled = !internalValueSelected && !allowGroupSelect;
          } else if (!isPureClientGroup) {
            option.disabled = false;
          }
          return option;
        }),
      );
    }
  }, [
    JSON.stringify(cellObj.internalPermissions),
    JSON.stringify(cellObj.groupPermissions),
    JSON.stringify(allPureClientGroupIds),
    // isPureClientGroup,
    isEmptyGroup,
  ]);

  useEffect(() => {
    if (
      !module &&
      isCustomizePermission &&
      permissionType === 'internalPermissions'
    ) {
      // setOptions([{ label: 'Module Name', value: [v] }]);
      setOptionValue([v]);
    }
  }, []);

  useEffect(() => {
    // if (!module && isCustomizePermission) {
    //   setOptions([{ label: 'Module Name', value: v }]);

    //   return;
    // }
    if (isCustomizePermission && module) {
      setOptions((preV) => {
        const newV = [...preV];
        newV[0].label = module;

        if (optionValue.find((item) => item === newV[0].value)) {
          onChange([newV[0].value], true);
        } else if (permissionType === 'groupPermissions') {
          onChange([], true);
        }
        return newV;
      });
    }

    if (!isCustomizePermission && module) {
      onChange(checkedPermission, true);
    }
  }, [module]);

  function onChange(checkedValues, isCodeTrigger = false) {
    !isCodeTrigger && formChange();
    let checkedV = PERMISSION_OPTION[v]?.filter((option, i) =>
      checkedValues?.find((itm) => itm === option.value),
    );
    if (isCustomizePermission) {
      checkedV = checkedValues.length ? [{ value: v, label: module }] : [];
    }

    const values = props.formInstance?.getFieldsValue(rowName);

    if (permissionType === 'internalPermissions') {
      values[rowName][rowIndex].display = checkedV.length !== 0;
    }

    if (permissionType === 'groupPermissions') {
      if (!Array.isArray(values[rowName][rowIndex][permissionType])) {
        values[rowName][rowIndex][permissionType] = [];
      }
      const targetGroupItem = values[rowName][rowIndex][permissionType]?.find(
        (i) => i.groupId === groupId,
      );
      if (targetGroupItem) {
        targetGroupItem.groupPermission = checkedValues;
      } else {
        values[rowName][rowIndex][permissionType].push({
          groupId,
          groupPermission: checkedValues || [],
        });
      }
    } else {
      values[rowName][rowIndex][permissionType] = checkedV;
    }
    // if (permissionType === 'internalPermissions') {
    //   // set client value
    //   const clientValue = values[rowName][rowIndex].clientPermissions;
    //   const groupValue = values[rowName][rowIndex].groupPermissions;
    //   if (clientValue?.length) {
    //     values[rowName][rowIndex].clientPermissions = clientValue.filter((i) =>
    //       checkedValues?.find((j) => j === i.value),
    //     );
    //   }
    // }
    if (
      ['internalPermissions', 'groupPermissions'].includes(permissionType) &&
      !isPureClientGroup
    ) {
      const internalValue = values[rowName][rowIndex].internalPermissions;
      const clientValue = values[rowName][rowIndex].clientPermissions;
      const groupValue = values[rowName][rowIndex].groupPermissions || [];
      const groupAllowedValues = groupValue
        .filter((i) => !allPureClientGroupIds.includes(i.groupId))
        .flatMap((i) => i.groupPermission);
      const internalValues = internalValue.map((i) => i.value);
      const allAvailablePermissionKey = [
        ...groupAllowedValues,
        ...internalValues,
      ];

      if (clientValue?.length) {
        values[rowName][rowIndex].clientPermissions = clientValue.filter((i) =>
          allAvailablePermissionKey.find((j) => j === i.value),
        );
      }
      groupValue.forEach((i) => {
        i.groupPermission = i.groupPermission.filter((key) =>
          allAvailablePermissionKey.includes(key),
        );
      });
    }
    props.formInstance.setFieldsValue(values);
    setOptionValue(checkedValues || []);
  }

  const onSystemSetting = location.pathname?.includes('/settings/systemModule');
  useEffect(() => {
    if (
      !onSystemSetting &&
      [
        DEFALUT_PERMISSION_SECTION.INSIGHT,
        DEFALUT_PERMISSION_SECTION.ANALYSIS,
      ].includes(v)
    ) {
      setOptions((prevOptions) =>
        originPermissions.map((i) => ({
          ...i,
          disabled: prevOptions?.find((j) => j.value === i.value)?.disabled,
        })),
      );
    }
  }, [originPermissions]);

  // useEffect(() => {
  //   if (location?.pathname.includes('create') && customizeModule.length === 0) {
  //     if (!isCustomizePermission) {
  //       if (companyInstance && permissionType === 'internalPermissions') {
  //         onChange(INTERNAL_DEFAULT_CHECKED);
  //       }
  //       if (!companyInstance && permissionType === 'internalPermissions') {
  //         onChange(INTERNAL_SELL_SIDE_DEFAULT_CHECKED);
  //       }
  //       if (companyInstance && permissionType === 'clientPermissions') {
  //         onChange(CLIENT_DEFAULT_CHECKED);
  //       }
  //       if (!companyInstance && permissionType === 'clientPermissions') {
  //         onChange(CLIENT_SELL_SIDE_DEFALUT_CHECKED);
  //       }
  //     }
  //   }
  // }, []);

  return (
    <Checkbox.Group
      className="permission-check-box"
      ref={inputRef}
      // {...props}
      // className="powerbi-disabled-checkbox"
      value={optionValue}
      options={options}
      defaultValue={isCustomizePermission ? [v] : optionValue}
      onChange={onChange}
    />
  );
});
export default PermissionCheckbox;
